<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p style="text-align: center;">To SJ for putting up with me.</p><br/>
<p style="text-align: center;">To C for encouraging me.</p><br/>
<p style="text-align: center;">To all the folk I shared an aeroplane or a simulator with, even the ones who gave me a hard time. I probably deserved it and without you all, this could never have been written.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?51e7e226